import { render, staticRenderFns } from "./Popover.vue?vue&type=template&id=4a32b6a8&scoped=true&"
import script from "./Popover.vue?vue&type=script&lang=ts&"
export * from "./Popover.vue?vue&type=script&lang=ts&"
import style0 from "./Popover.vue?vue&type=style&index=0&id=4a32b6a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a32b6a8",
  null
  
)

export default component.exports